module.exports = __webpack_public_path__ + "assets/img/37_1556.6728d26f.jpg";